/* "I don't know my model": the result cards.

   The extension's result card lists the range, the type, overall length and
   width as small print, the deck length on its own line and a red "This is
   mine" link. The rest of the store describes a trailer one way: the name,
   then three figures (Deck Length, Deck Width, Load Capacity) with the label
   under each, as on the picked trailer panel and the model sheet. This builds
   that block inside each result card and fx-quiz.css hides the extension's
   own lines beside it. The whole card is still the button.

   WHERE THE FIGURES COME FROM. Deck length and width are in the selector
   matrix the extension already has on the page (getSelectorApi). Load capacity
   is not; it comes from the app proxy's modelSpecs, the same source as the
   Weight Ratings accordion and the picked trailer panel (fx-ext-find.js). A
   figure that is missing is left out rather than shown as a dash.

   The extension rebuilds the results panel on every step, so each pass checks
   what is on screen against what it would build and only writes when they
   differ. */
(function () {
  'use strict';

  var SPECS_URL = '/apps/vin-search/modelSpecs';
  var NOTE = 'Pick the closest. You can still change model on the results screen.';
  var caps = null;
  var asked = false;

  function key(s) {
    return String(s || '').toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim();
  }

  function loadCaps() {
    if (asked) return;
    asked = true;
    fetch(SPECS_URL, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        caps = {};
        ((j && j.specs) || []).forEach(function (m) {
          (m.groups || []).forEach(function (g) {
            (g.rows || []).forEach(function (row) {
              if (/load\s*capacity/i.test(row.label || '')) {
                caps[key(m.modelName)] = String(row.value || '').trim();
              }
            });
          });
        });
        tick();
      })
      .catch(function () { caps = {}; tick(); });
  }

  function selectorApi() {
    var el = document.querySelector('vin-search-modal');
    try { return el && typeof el.getSelectorApi === 'function' ? el.getSelectorApi() : null; }
    catch (e) { return null; }
  }

  /* 16'5" reads as 16' 5" everywhere else on the store. */
  function feet(v) {
    return String(v || '').replace(/'\s*(\d)/, "' $1").trim();
  }

  /* "3,086 lbs (estimated)" keeps the figure and drops the qualifier here. */
  function figure(raw) {
    var m = /^(.*?)\s*\([^)]*\)\s*$/.exec(raw || '');
    return (m ? m[1] : raw || '').trim();
  }

  /* "SHIFTR 1883" on the card, "SHIFTR" in the spec sheet: exact name first,
     then the longest spec name found in it as whole words, the same rule as
     fx-render.js and fx-ext-find.js. Without it the SHIFTR result had two
     figures where every other trailer has three. */
  function capFor(k) {
    if (!k || !caps) return '';
    if (caps[k]) return caps[k];
    var hay = ' ' + k + ' ', best = '';
    for (var n in caps) {
      if (!Object.prototype.hasOwnProperty.call(caps, n)) continue;
      if (n && n.length > best.length && hay.indexOf(' ' + n + ' ') !== -1) best = n;
    }
    return best ? caps[best] : '';
  }

  function cellsFor(name) {
    var api = selectorApi();
    var m = null;
    try { m = api && api.modelByName ? api.modelByName(name) : null; } catch (e) { m = null; }
    var out = [];
    if (m && m.deck) out.push([feet(m.deck), 'Deck Length']);
    if (m && m.deckW) out.push([String(m.deckW).trim(), 'Deck Width']);
    var cap = caps ? figure(capFor(key(name))) : '';
    if (cap) out.push([cap, 'Load Capacity']);
    return out;
  }

  function build(card) {
    var body = card.querySelector('.ident-result-body');
    if (!body) return;
    var nameEl = card.querySelector('.ident-result-name');
    var name = card.getAttribute('data-name') || (nameEl ? nameEl.textContent : '');
    if (!name) return;
    var cells = cellsFor(name);
    var sig = name + '|' + cells.map(function (c) { return c[0]; }).join('|');
    var box = body.querySelector('.fx-res');
    if (box && box.getAttribute('data-sig') === sig) return;

    if (!box) {
      box = document.createElement('span');
      box.className = 'fx-res';
      body.appendChild(box);
    }
    box.setAttribute('data-sig', sig);
    box.textContent = '';

    var n = document.createElement('span');
    n.className = 'fx-res__name';
    n.textContent = name;
    box.appendChild(n);

    if (cells.length) {
      var dims = document.createElement('span');
      dims.className = 'fx-res__dims';
      cells.forEach(function (c) {
        var cell = document.createElement('span');
        cell.className = 'fx-res__cell';
        var b = document.createElement('b');
        b.textContent = c[0];
        var l = document.createElement('span');
        l.textContent = c[1];
        cell.appendChild(b);
        cell.appendChild(l);
        dims.appendChild(cell);
      });
      box.appendChild(dims);
    }
    if (!body.classList.contains('has-fx-res')) body.classList.add('has-fx-res');
  }

  function tick() {
    var cards = document.querySelectorAll('.ident-result');
    if (!cards.length) return;
    loadCaps();
    for (var i = 0; i < cards.length; i++) build(cards[i]);
    /* The extension's note explains why one figure is bold. There is no bold
       figure now, so it keeps only the part that still helps. */
    var notes = document.querySelectorAll('.ident .ident-note');
    for (var j = 0; j < notes.length; j++) {
      if (notes[j].textContent !== NOTE) notes[j].textContent = NOTE;
    }
  }

  function start() {
    tick();
    new MutationObserver(tick).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
